export default "__VITE_ASSET__B_70$s8K__"